import catStep1 from './cat/catStep1.png'
import catStep2 from './cat/catStep2.png'
import catStep3 from './cat/catStep3.png'
import deStep1 from './de/deStep1.png'
import deStep2 from './de/deStep2.png'
import deStep3 from './de/deStep3.png'
import enStep1 from './en/enStep1.png'
import enStep2 from './en/enStep2.png'
import enStep3 from './en/enStep3.png'
import esStep1 from './es/esStep1.png'
import esStep2 from './es/esStep2.png'
import esStep3 from './es/esStep3.png'
import frStep1 from './fr/frStep1.png'
import frStep2 from './fr/frStep2.png'
import frStep3 from './fr/frStep3.png'
import itStep1 from './it/itStep1.png'
import itStep2 from './it/itStep2.png'
import itStep3 from './it/itStep3.png'
import ptBrStep1 from './ptBr/ptBrStep1.png'
import ptBrStep2 from './ptBr/ptBrStep2.png'
import ptBrStep3 from './ptBr/ptBrStep3.png'
import ptPtStep1 from './ptPt/ptStep1.png'
import ptPtStep2 from './ptPt/ptStep2.png'
import ptPtStep3 from './ptPt/ptStep3.png'

type LocaleImages = {
  [key: string]: string[]
}

const images: LocaleImages = {
  en: [enStep1, enStep2, enStep3],
  'en-gb': [enStep1, enStep2, enStep3],
  'en-us': [enStep1, enStep2, enStep3],
  de: [deStep1, deStep2, deStep3],
  es: [esStep1, esStep2, esStep3],
  'es-mx': [esStep1, esStep2, esStep3],
  fr: [frStep1, frStep2, frStep3],
  it: [itStep1, itStep2, itStep3],
  pt: [ptPtStep1, ptPtStep2, ptPtStep3],
  'pt-br': [ptBrStep1, ptBrStep2, ptBrStep3],
  ca: [catStep1, catStep2, catStep3],
}

export const getImagesByLocale = (locale: string): string[] => {
  return images[locale] || [enStep1, enStep2, enStep3]
}
